<template>
<div >

    <Navbar></Navbar>
    <div class="main-content">
		<div class="container">

            <div class="import-box" style="max-width: 560px;">
                <h2 class="mt-4 text-center">Solicitar despachos</h2>
                <p class="text-center">
                    Busque por DUA tránsito y seleccione los vehículos que desea despachar
                </p>
            </div>
		</div>

        <Loader :show="saving || loading"></Loader>

        <div class="container">
            <div class="row">
                <div class="col-6">

                    <div class="form-group">
                        <label>DUA tránsito</label>
                        <div class="input-group">
                            <input type="text" 
                                class="form-control" 
                                placeholder="Número DUA tránsito" 
                                v-model="searchTerms"
                                @keypress.enter="searchCars(), touched=false"
                                >
                            <div class="input-group-append">
                                <button @click="searchCars()" class="btn btn-outline-secondary" type="button">Buscar</button>
                            </div>
                        </div>
                    </div>

                    <div class="label mt-4">
                        Vehículos disponibles para despachar
                    </div>
                    <div class="d-flex">
                        <div class="btn btn-xs btn-light mr-2" @click="selectAll()">Seleccionar todos</div>
                        <div class="btn btn-xs btn-light mr-2" @click="deselectAll()">Deseleccionar todos</div>
                    </div>


                    <div class="alert alert-warning" v-if="touched && !loading && cars.length==0">
                        No se han encontrado vehículos con número de DUA tránsito {{searchTerms}}
                    </div>

                    <table class="table mt-2 mb-4" v-if="filteredCars.length>0">
                        <tr class="table-head">
                            <td>Chasis</td>
                            <td>Vehículo</td>
                            <td>Cliente</td>
                        </tr>
                        <tr v-for="item of filteredCars" :key="item.id"  @click="selectCar(item)">
                            <td>{{item.chassis_number}}</td>
                            <td>
                                <div class="tc">
                                    <span class="text-primary">{{item.brand.title}}</span>
                                    <span >{{item.model}}</span>
                                </div>
                            </td>
                            <td>
                                <div class="tc">
                                    <span class="text-primary">{{item.client.name}}</span>
                                    <span >{{item.client.business_name}}</span>
                                </div>
                            </td>
                        </tr>
                    </table>

                </div>

                <div class="col-6">

                    <b-form-group label="DUA Importación" >
                        <b-form-input
                            v-model="form.dua_dispatch"
                            placeholder="Número de dua importación"
                            :class="{'is-invalid':validation.hasError('form.dua_dispatch')}"
                        ></b-form-input>
                        <b-form-invalid-feedback>Ingrese el número de dua</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Comprobante" >
                        <UploadFile 
                            v-model="form.file" 
                            placeholder="Adjuntar comprobante"
                            :invalid="validation.hasError('form.file.id')"
                            :invalid-text="'Debe subir el comrpobante de despacho'"
                        ></UploadFile>
                    </b-form-group>

                    <div class="label mt-4">
                        Vehículos seleccionados para despachar
                    </div>

                    <div class="alert alert-danger" v-if="validation.hasError('form.cars')">Debe seleccionar al menos un vehículo</div>

                    <div class="overflow-hidden mt-3">
                        <button type="submit" class="btn btn-primary pull-right" @click="save()" >Confirmar solicitud</button>
                    </div>

                    <table class="table mt-2 mb-4" v-if="form.cars.length>0">
                        <tr class="table-head">
                            <td></td>
                            <td>Chasis</td>
                            <td>Vehículo</td>
                            <td>Cliente</td>
                        </tr>
                        <tr v-for="(item, index) of form.cars" :key="item.id" @click="deselectCar(index)">
                            <td>
                                <div class="check checked"></div>
                                <!-- <div class="btn btn-xs btn-light" @click="deselectCar(index)"><i class="fa fa-times"></i></div> -->
                            </td>
                            <td>{{item.chassis_number}}</td>
                            <td>
                                <div class="tc">
                                    <span class="text-primary">{{item.brand.title}}</span>
                                    <span >{{item.model}}</span>
                                </div>
                            </td>
                            <td>
                                <div class="tc">
                                    <span class="text-primary">{{item.client.name}}</span>
                                    <span >{{item.client.business_name}}</span>
                                </div>
                            </td>
                        </tr>
                    </table>

                </div>
            </div>
        </div>        

    </div>

</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import UploadFile from '@/components/UploadFile'
import Navbar from '@/components/Navbar'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'requestCustomsDispatchModal',
	components:{
        Loader,
        Navbar,
		UploadFile
    },
    mixins: [mixins],
	data () {
		return {
            touched: false,
            searchTerms:null,
			form: {
				file:{
					id: null
				},
                dua_dispatch: null,
                cars:[]
            },
            cars: [],
			loading: false,
			saving: false,
		}
    },
    computed: {
        filteredCars: function () {
			return this.cars.filter((car) => {
				if( this.form.cars.map( el => el.id ).indexOf(car.id) < 0 ){
					return car
				}
			}
		)}
    },
	validators: {
		'form.file.id': function (value) {
			return Validator.value(value).required();
		},
		'form.dua_dispatch': function (value) {
			return Validator.value(value).required();
        },
        'form.cars': function (value) {
			return Validator.custom( () => {
                if(value.length<=0){
					return true
				}
			})
		},
    },
	methods: {
        selectAll(){
            this.filteredCars.map( el => this.selectCar(el) );
        },
        deselectAll(){
            this.form.cars.map( el => this.deselectCar(el) );
        },
        selectCar(event){
            this.form.cars.push(event)
        },
        deselectCar(index){
            this.form.cars.splice(index,1)
        },
		searchCars(){
            this.touched=true
            // this.loading = true
			this.$apollo.query({
				query: gql`query ($status: String, $dua_transit: String) {
					carsAll(status: $status, dua_transit: $dua_transit) {
                        id
                        client{
                            name
                        }
                        model
                        brand{
                            title
                        }
                        motor_number
                        chassis_number
                        status
                        statusText
					}
				}`,
				variables: {
					dua_transit: this.searchTerms,
					status: 'IN_CUSTOMS_DEPOSIT',
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
                this.loading = false
				this.cars = data.data.carsAll;
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
                
                var cars = []
                this.form.cars.forEach(car=>{cars.push(car.id)})
				let dataInput = {
					dua_dispatch: this.form.dua_dispatch,
                    file_id     : this.form.file.id,
					cars 		: cars
				}
                this.create(dataInput)
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:RequestDispatchInput! ){
					requestDispatch( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
                this.$router.push('/cars');
                this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
	}
}


</script>


<style lang="scss" scoped>
.table{

    .check{
        width: 18px;
        height: 18px;
        border: solid 2px #24a2d2;
        border-radius: 3px;

        &::before{
            content:'';
            width: 8px;
            border-radius: 2px;
            height: 8px;
            background-color: #fff;
            margin: 3px;
            display: block;
        }
    }

    

    .check.checked{
        
        &::before{
            background-color: #24a2d2;
        }
    }
    
}
</style>